import React from 'react';
import { Card, CardContent, CardMedia, Typography,Link } from '@material-ui/core/';
import moment from 'moment';
import ImageRandom from './images/random-images'

import useStyles from './styles.js';


const Post = ({ post }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      
      <CardMedia className={classes.media} image={post.selectedFile || ImageRandom()} title={post.title}  />
      <div className={classes.overlay}>

        <Typography variant="h8">{'נוסף על ידי'}&nbsp;{post.creator} </Typography>     
           <br></br>

        <Typography variant="h15">{moment(post.createdAt).fromNow()}</Typography>
        <br></br>
        <Typography variant="h5">
        {'הצטרפות לקבוצה '}
        <Link href={post.link} onClick={post.link} color="inherit">
        {'לחץ כאן'}
  </Link>
  </Typography>
      </div>

      <div className={classes.details}>
        <Typography variant="body2" color="textSecondary" component="h2">{post.tags.map((tag) => `מוסד אקדמי - ${tag} `)}</Typography>

      </div>
      <Typography className={classes.title} gutterBottom variant="h5" component="h2">{post.title}</Typography>
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">{post.message}</Typography>
      </CardContent>

    </Card>
  );
};

export default Post;
